export default (stat) => {
  const data = (stat || []).reduce((prev, current) => ({
    responses: prev.responses + current.responses,
    requests: prev.requests + current.requests,
    winRate: prev.winRate + current.winRate,
    wins: prev.wins + current.wins,
    responseRate: prev.responseRate + current.responseRate,
    spent: prev.spent + current.spent,
    clicks: prev.clicks + current.clicks,
  }), {
    responses: 0,
    requests: 0,
    winRate: 0,
    wins: 0,
    responseRate: 0,
    spent: 0,
    clicks: 0,
  });

  return {
    ...data,
    winRate: data.wins / data.responses,
    responseRate: (data.responses / data.requests),
    cpc: data.spent / data.clicks,
    ctr: data.clicks / data.wins * 100,
    avgCPM: data.spent / data.wins * 1000,
  };
};
